import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';

import { studentExamApi } from '../../api/examApi';
import { parseApiError } from '../../lib/apiErrors';

export default function SharedExamEntryPage() {
  const { examToken } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const resolveLink = async () => {
      try {
        const response = await studentExamApi.resolveExamLink(examToken);
        const data = response.data;

        if (!data.attempt_id) {
          navigate(`/student/exam/${data.exam_id}`, { replace: true });
          return;
        }

        if (data.attempt_status === 'in_progress') {
          navigate(`/student/exam/${data.exam_id}/attempt/${data.attempt_id}`, { replace: true });
          return;
        }

        if (data.attempt_status === 'submitted' || data.attempt_status === 'evaluated') {
          toast.message(`You already have a ${data.attempt_status.replace('_', ' ')} attempt for ${data.exam_title}.`);
          navigate(`/student/results/${data.attempt_id}`, { replace: true });
          return;
        }

        navigate(`/student/exam/${data.exam_id}`, { replace: true });
      } catch (error) {
        toast.error(parseApiError(error, 'This exam link is not available for your account.').message);
        navigate('/student', { replace: true });
      }
    };

    resolveLink();
  }, [examToken, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950">
      <div className="text-center">
        <div className="animate-spin w-10 h-10 border-4 border-primary border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-slate-600 dark:text-slate-400">Connecting your exam link...</p>
      </div>
    </div>
  );
}
